import React from 'react';

import CollectionsTaxonomyOverlay from './collections-taxonomy-overlay';
import MediaBar from './media-bar';
import TaxonomyMediaPanel from './taxonomy-media-panel';

import '../../styles/collections/taxonomy-bar.scss';

export default class TaxonomyBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mediaContext: (props.mediaContext) ? props.mediaContext : 'All'
    };

    this.handleTabClick = this.handleTabClick.bind(this);
  }

  handleTabClick(label) {
    this.setState({
      mediaContext: label
    });
  }
  
  render() {
    return (
      <aside aria-label={`${this.props.position} Filter Controls`}>
        <CollectionsTaxonomyOverlay
          mediaContext={ this.state.mediaContext }
          handleTabClick={ this.handleTabClick }
        />
        <div className="collections-taxonomy-bar">
          <MediaBar
            mediaContext={ this.state.mediaContext }
            handleTabClick={ this.handleTabClick }
          />
          <TaxonomyMediaPanel
            mediaGroup={ this.state.mediaContext }
            filterContext={ this.props.filterContext }
          />
        </div>
      </aside>
    );
  }
}